<template>
  <div>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">
                Electronic Delivery Order - List
              </h4>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow class="mb-1">
            <CCol sm="12">
              <CInput
                class="float-right"
                placeholder="Search By Stt"
                v-model="request.stt_no"
                @input="onSearchStt()"
              >
                <template #prepend-content>
                  <CIcon name="cil-magnifying-glass" />
                </template>
              </CInput>
              <CInput
                class="float-right pr-2"
                type="date"
                v-model="request.date"
                @change="onSearchDate()"
              >
                <template #prepend-content>
                  <CIcon name="cil-magnifying-glass" />
                </template>
              </CInput>
            </CCol>
          </CRow>
          <CDataTable
            hover
            striped
            :items="data"
            :fields="fields"
            :items-per-page="20"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #action="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0"
                    @click="viewFile(data.item.url)"
                    >View</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-custom">
            <div class="pagination-nav">
              <div
                class="pagination-btn-refresh"
                @click="getEDOListData('REFRESH')"
              >
                Refresh
              </div>
              <div class="pagination-btn-back" @click="getEDOListData('BACK')">
                back
              </div>
              <div class="pagination-page-title">{{ this.request.page }}</div>
              <div class="pagination-btn-next" @click="getEDOListData('NEXT')">
                next
              </div>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </div>
</template>

<script>
import EDOUseCase from "./app/usecase/index.js";
import "./app/types";
export default {
  data() {
    return {
      data: [],
      request: {
        page: 1,
        limit: 20,
        date: "",
        stt_no: "",
      },
      fields: [
        { key: "id", label: "ID", _style: "width:10%" },
        { key: "stt_no", label: "Stt No", _style: "width:35%" },
        { key: "created_at", label: "Created At", _style: "width:35%" },
        { key: "action", label: "action", _style: "width:20%" },
      ],
      debounce: {
        timeout: 0,
        duration: 1000,
      },
    };
  },
  methods: {
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    async getEDOListData(action) {
      try {
        this.validatePagination(action);
        var queryString = Object.keys(this.request)
          .map((key) => key + "=" + this.request[key])
          .join("&");
        const { data, err } = await EDOUseCase.getAll(queryString);
        if (err) {
          this.validateNextPagination(action);
          this.err = err;
        } else {
          this.err = "";
          if (data) {
            window.scrollTo(0, 0);
            this.data = data;
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    validatePagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page + 1;
      } else if (action === "BACK") {
        if (this.request.page > 1) {
          this.request.page = this.request.page - 1;
        }
      } else if (action === "REFRESH") {
        this.request.page = 1;
      } else {
        this.request.page = 1;
      }
    },
    validateNextPagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page - 1;
      } else {
        this.data = [];
      }
    },
    viewFile(url) {
      window.open(url);
    },
    onSearchStt() {
      if (this.request.stt_no.length > 4 || this.request.stt_no.length == 0) {
        setTimeout(this.getEDOListData(), this.debounce.duration);
      }
    },
    onSearchDate() {
      this.getEDOListData();
    },
  },
  beforeMount() {
    this.getEDOListData();
  },
  beforeDestroy() {
    clearTimeout(this.debounce.timeout)
  },
};
</script>
